import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const mediaSrc = (url) => (url ? `${BACKEND_URL}${url}` : null);

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const r = await api.request({
        method,
        url,
        data,
        ...config,
        headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` },
      });
      return r.data;
    },
    [getToken],
  );
}
